export default "/_next/static/media/banner.5c725907bfda86ee140688cccaaa7627.mp4";